import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "microservices" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_microservices_actions = _resolveComponent("microservices-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_microservices_filters = _resolveComponent("microservices-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_microservices_list_item = _resolveComponent("microservices-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_microservices_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createMicroservice,
          onUpdate: _ctx.updateMicroservice
        }, null, 8, ["loading", "is-create", "is-update", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Микросервисы" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "primary small mr-2",
            onClick: _ctx.importAllRoutes
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Импортировать все routes ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.startCreate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить микросервис ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_microservices_filters, {
        loading: _ctx.state.microservices.is_loading,
        onSearch: _ctx.onSearch,
        onReset: _ctx.onReset,
        class: "mb-5"
      }, null, 8, ["loading", "onSearch", "onReset"]),
      _createElementVNode("div", _hoisted_4, [
        (
                    _ctx.state.microservices.is_failed &&
                    !_ctx.state.microservices.failure.error_state.is_cancel
                )
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.microservices.is_loading,
              text: "При получении списка микросервисов произошла ошибка",
              "error-message": _ctx.state.microservices.failure.error_state.message,
              "error-url": _ctx.state.microservices.failure.error_state.url,
              "error-status": _ctx.state.microservices.failure.error_state.status,
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMicroservices(_ctx.state.microservices.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.state.microservices.is_loading,
              items: _ctx.state.microservices.list,
              pagination: "",
              "pagination-current-page": _ctx.state.microservices.pagination.current_page,
              "pagination-total-pages": _ctx.state.microservices.pagination.total_pages,
              onChangePage: _ctx.loadMicroservices
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_microservices_list_item, {
                  item: item,
                  "is-importing": _ctx.state.is_importing,
                  onUpdate: _ctx.startUpdate
                }, null, 8, ["item", "is-importing", "onUpdate"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}